<!--COMPONENT ONLY USED ON OVERVIEWSTEP COMPONENT-->
<a [routerLink]="allowOnClick ? docId : null"
   (contextmenu)="onClickCard()"
   (click)="onClickCard()"
   [state]="{context: text}">
  <div id="card-{{docId}}" [ngClass]="{'preview': isPreview}" class="document-card">
    <div class="document-info">
      <div class="document-publication-date">
        <i class="ph-bold ph-calendar-check color-basic-600"></i>
        @if (publicationDate) {
          <div>{{publicationDate | date:'dd MMMM yyyy':'':'fr' }}</div>
        } @else {
          <div>{{ 'content.date_not_detected' | translate }}</div>
        }
      </div>
      <div class="document-source">
        <i class="ph-bold ph-file-text color-basic-600"></i>
        <div [style.font-style]="(displayedPublicationType === TerritoryWatchProjectPublicationTypeEnum.NON_DETECTED) ? 'italic' : 'normal'"
             class="category-name d-flex align-self-center">{{displayedPublicationType}}</div>
      </div>
      <div class="document-website">
        <i class="ph-bold ph-globe"></i>
        <div>{{ website }}</div>
      </div>
    </div>

    <div class="document-head">
      <div class="document-title"
           data-cy="article-card-title"
           [innerHTML]="title && (title | articleTitleCase)">
      </div>
    </div>

    <div class="document-territories" id="territory-section-{{docId}}">
      <i class="ph-bold ph-map-pin"></i>
      @if (territories && territories.length) {
        <div class="document-territories-list" id="territories-list-{{docId}}">
          @for (territory of territories; track territory.uid; let idx = $index) {
            <span>{{territory['name']}}</span>
            @if (idx !== territories.length - 1) {
              <span>|</span>
            }
          }
        </div>
        @if (displayReadMore) {
          <div id="read-more-{{docId}}"
               class="document-territories-more"
               (click)="onReadMoreClick($event)"
               [ngbTooltip]="territoryTooltip"
               tooltipClass="simple-tooltip"
               placement="bottom-right">
            <i class="ph-bold ph-plus"></i>
            <div>{{"content.see-more"| translate}}</div>
          </div>
        }
      } @else {
        <div class="document-no-territories">
          {{'content.non-detected-territory' | translate}}
        </div>
      }
    </div>

    @if (text) {
      <div class="document-text" data-cy="article-card-text" [innerHTML]="text"></div>
    } @else {
      <div class="document-text fst-italic" [innerHTML]="'content.undetected-text' | translate"></div>
    }

    @if (nbNewDocuments) {
      <div class="document-text fw-bold">
        <span>{{nbNewDocuments}} </span>
        <span>{{(nbNewDocuments > 1 ? 'content.new-documents' : 'content.new-document') | translate}}</span>
      </div>
    }
  </div>
</a>


<ng-template #territoryTooltip class="territory-tooltip">
      <span *ngFor="let territory of territories; let i = index">
            <span class="territory-name fw-bold color-white">{{territory['name']}}</span>
            <span *ngIf="territories && i < territories.length - 1"
                  class="separator color-basic-600 fw-light"> | </span>
      </span>
</ng-template>
